import {getName} from "./function"

export const getLabelValueArray = (arrName = [], label = 'name', value = '_id') => {
    const finalArray = []
    arrName?.forEach(e => {
        /** ...e for get all values, used in ATS source */
        let data = {...e, label: label === 'fullName' ? getName(e) : e[label], value: e[value]}
        finalArray?.push(data)
    })
    return finalArray
}
export const getKeyValue = (arrName = [], label = 'name', value = '_id') => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e[value]] = e[label]
    })
    return finalObject
}

export const getKeyObj = (arrName = [], value = '_id') => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e[value]] = e
    })
    return finalObject
}

export const getLabelValue = (arrName = [], include, key = 'name',) => {
    const finalArray = []
    arrName?.forEach(e => {
        /** ...e for get all values, used in ATS source */
        let data = {...e, label: key === 'fullName' ? getName(e) : e[key], value: e._id}
        if (key?.length !== 0 && include) data[include] = e[include]
        finalArray?.push(data)
    })
    return finalArray
}
export const getLabelForFF = (arrName = []) => {
    const finalArray = []
    arrName?.forEach(e => finalArray?.push({label: `${e.firstName} ${e.lastName}`, value: e._id}))
    return finalArray
}

export const getContryLanguageLabelValue = (arrName = []) => {
    const finalArray = []
    arrName?.forEach(e => finalArray?.push({label: e.name, value: e.name}))
    return finalArray
}

export const getLanguageKeyValue = (arrName) => {
    const finalObject = {}
    arrName?.forEach(e => {
        finalObject[e.name] = e.name
    })
    return finalObject
}

export const getKeyName = (arrList = [], id) => {
    if (arrList && arrList?.length) return arrList?.find(_ => _.value == id)
}
export const getLabelValueFromId = (arrList = [], id, key = '_id', label = 'name') => {
    if (arrList && arrList?.length) {
        const data = arrList?.find(_ => _[key] === id)
        if (data) return {label: data?.[label], value: data?.[key]}
        else return null
    }
}

export const getKeyLabel = (arrList = [], id) => {
    if (arrList && arrList?.length) return arrList?.find(_ => _.value === id)?.label;
}

export const getKeyValueColorCode = (arrName = []) => {
    const finalObjectColor = {}
    arrName?.forEach(e => {
        finalObjectColor[e._id] = e.color
    })
    return finalObjectColor
}

export const getLabelValueUserImage = (arrName = []) => {
    const finalArray = []
    arrName?.forEach(e => finalArray?.push(getUserInfoObject(e)))
    return finalArray
}


export const getUserInfoObject = (userInfo = {}) => {
    return {
        ...userInfo,
        label: getName(userInfo),
        name: getName(userInfo),
        value: userInfo?.value || userInfo?._id || ''
    }
}

export const getSplitRange = (range, operator = '-', startKey = 'from', endKey = 'to') => {
    let obj;
    let arr = range.split(operator)
    if (arr.length !== 1) {
        obj = {
            [startKey]: +arr[0],
            [endKey]: +arr[1]
        }
    } else obj = {[startKey]: +arr[0].replace('+', '').slice(0, 3)}
    return obj
}